import {Context, FC, useContext} from 'react'
import {useMutation, useQueryClient} from 'react-query'
import {BASE_URL} from '../../config'
import axios from 'axios'
import toast from 'react-hot-toast'

const READ_NOTIFICATION_URL = `${BASE_URL}/api/protect/readNotification`

type Props = {
  context: Context<any>
}

const SelectNotification: FC<Props> = ({context}) => {
  const queryClient = useQueryClient()
  const {selected} = useContext(context)

  const {mutateAsync: readNotification} = useMutation({
    mutationFn: async (ids: number[]) => {
      const response = await axios.put(READ_NOTIFICATION_URL, {ids})

      return response
    },
    onSuccess: () => {
      queryClient.invalidateQueries('notificationLit')
      toast.dismiss()
    },
  })

  const handleMarkRead = () => {
    toast.loading('Processing..')
    readNotification(selected)
  }

  return (
    <>
      {selected.length > 0 && (
        <div className='d-flex justify-content-end align-items-center'>
          <div className='fw-bolder me-5'>
            <span className='me-2'>{selected.length}</span> Selected
          </div>

          <button type='button' className='btn btn-primary' onClick={handleMarkRead}>
            Mark As Read
          </button>
        </div>
      )}
    </>
  )
}

export default SelectNotification
